import React from 'react';

const AudioOutput = ({text}) => {
  return (
    <div className="flex items-center justify-center h-full">
      {text}
      {/* <img src="https://dashboard.codeparrot.ai/api/image/Z6-YNeepongUSRkc/sound-ba.png" alt="audio" className="w-[100px] h-[50px]" /> */}
      {/* Add audio controls here */}
    </div>
  );
};

export default AudioOutput;
